module.exports = __webpack_public_path__ + "static/img/sx.1a98c78.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sx.png
// module id = LPmJ
// module chunks = 0